import React from 'react';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import Separator from '../../../../core/layout/Separator';
import ContentMasteryTestFailureAttemptRateTableContainer from './mastery-test/ContentMasteryTestFailureAttemptRateTableContainer';
import ContentMasteryTestSpeechRateTableContainer from './mastery-test/ContentMasteryTestSpeechRateTableContainer';
import ContentMasteryTestRepeatRateTableContainer from './mastery-test/ContentMasteryTestRepeatRateTableContainer';
import ContentMasteryTestErrorRateTableContainer from './mastery-test/ContentMasteryTestErrorRateTableContainer';

const ContentMasteryTestListScene = () => (
  <div>
    <Row>
      <Column size={6}>
        <ContentMasteryTestFailureAttemptRateTableContainer />
      </Column>
      <Column size={6}>
        <ContentMasteryTestSpeechRateTableContainer />
      </Column>
    </Row>
    <Separator />
    <Row>
      <Column size={6}>
        <ContentMasteryTestRepeatRateTableContainer />
      </Column>
      <Column size={6}>
        <ContentMasteryTestErrorRateTableContainer />
      </Column>
    </Row>
  </div>
);

export default ContentMasteryTestListScene;
